import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';
import { FastCeckinUserInfoFormType } from './fast-checkin-user-info-form';
import { CustomValidatorsFactory } from 'src/app/base/shared/validators/custom-validators-factory';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FastCheckinType } from 'src/app/base/models/models.swagger.generated';

@Component({
  selector: 'app-fast-checkin-step-user-info',
  templateUrl: './fast-checkin-step-user-info.component.html',
  styleUrls: ['./fast-checkin-step-user-info.component.scss'],
  imports: [TranslateModule, ReactiveFormsModule, AppErrorMessagesComponent, TooltipModule, DropDownListModule]
})
export class FastCheckInStepUserInfoComponent implements OnInit {

  @Input() public zoneName: string;
  @Input() public userInfoForm: FormGroup<FastCeckinUserInfoFormType>;
  @Input() public fastCheckinType: FastCheckinType;

  @Output() public next = new EventEmitter<FormGroup<FastCeckinUserInfoFormType>>();

  public get welcomeTextTranslationKey(): string {
    switch (this.fastCheckinType) {
      case FastCheckinType.PayTillNow:
        return 'i18n.domain.fast-checkin.step-user-info.welcome-text-pay-till-now';
      case FastCheckinType.FastCheckIn:
        return 'i18n.domain.fast-checkin.step-user-info.welcome-text-fast-checkin';
      default:
        return 'i18n.domain.fast-checkin.step-user-info.welcome-text-fast-checkin';
    }
  }

  public get emailInfoTextTranslationKey(): string {
    switch (this.fastCheckinType) {
      case FastCheckinType.PayTillNow:
        return 'i18n.domain.fast-checkin.step-user-info.email-info-text-pay-till-now';
      case FastCheckinType.FastCheckIn:
        return 'i18n.domain.fast-checkin.step-user-info.email-info-text-fast-checkin';
      default:
        return 'i18n.domain.fast-checkin.step-user-info.email-info-text-fast-checkin';
    }
  }

  private readonly destroyRef = inject(DestroyRef);

  constructor(private fb: FormBuilder) {
  }

  ngOnInit() {
    if (!this.userInfoForm) {
      this.userInfoForm = this.fb.group({
        controlPlate: this.fb.control<string>(null, [Validators.required, Validators.maxLength(10), CustomValidatorsFactory.controlPlateValidatorFn()]),
        email: this.fb.control<string>(null, Validators.email)
      });
    }

    this.setupControlPlateUppercase();
  }

  public onNext() {
    this.next.emit(this.userInfoForm);
  }

  private setupControlPlateUppercase(): void {
    const controlPlateControl = this.userInfoForm?.controls.controlPlate;
    if (!controlPlateControl) {
      return;
    }

    controlPlateControl.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(value => {
        const upperCaseValue = value ? value.toUpperCase() : value;
        if (upperCaseValue !== value) {
          controlPlateControl.setValue(upperCaseValue, { emitEvent: false });
        }
      });
  }
}
